import { useMutation } from '@tanstack/react-query';
import { generateContent, ContentGenerationRequest, ContentGenerationResponse } from '../services/contentService';

/**
 * Hook for generating content using the AI Coach API
 * @returns Mutation object for content generation
 */
export const useContentGeneration = () => {
  return useMutation<ContentGenerationResponse, Error, ContentGenerationRequest>({
    mutationFn: (data: ContentGenerationRequest) => generateContent(data),
    onError: (error) => {
      console.error('Content generation error:', error);
    },
  });
}; 